import { Serializable } from "./serializable";
import Address from "@/models/address";

export type UserStatusType = "logged" | "logging" | "notLogged";

interface UserPermissions {
  canSeeAdminPages: boolean;
  serviceIds?: number[];
  eventIds?: number[];
}

export class User implements Serializable<User> {
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  place?: Address = undefined;
  cap: string = "";
  address: string = "";
  city: string = "";
  province: string = "";
  phone: string = "";
  permissions: UserPermissions = {
    canSeeAdminPages: false
  };
  type?: string;

  deserialize(input: any): User {
    this.type = input.role || null;
    this.firstName =
      this.type === "Host" ? input.company.name : input.first_name || "";
    this.lastName = input.last_name || "";
    this.email = input.email || "";
    this.place = new Address().deserialize(input.place) || null;
    this.address = input.address || "";
    this.phone = input.phone || "";
    return this;
  }

  requestSerialize(input: any): any {
    return {
      first_name: input.firstName,
      last_name: input.lastName,
      email: input.email,
      phone: input.phone,
      place_attributes: new Address().userRequestSerialize(input.place)
    };
  }
}
